export const QUOTEMAGIC_PARTNER_PHONE_NUMBER = '866-251-5111';
